import { useEffect, useRef, useState } from "react";
import {
    Button,
    Card,
    DatePicker,
    Form,
    Input
} from "antd";
import { t } from "i18next";
import { useHistory, useParams } from "react-router-dom";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import ApiService from "../../../core/service/ApiService";
import Helper from "../../../core/Helper";
import moment from "moment";
import { useLocation } from "react-router-dom";

export default function ReminderCreateEdit() {
    const formRef = useRef();
    const history = useHistory();
    const [reminder, setReminder] = useState({});
    const query = new URLSearchParams(useLocation().search);
    const patientId = query.get("patientId");
    const reminderId = query.get("reminderId");

    const getReminder = async () => {
        if (reminderId) {
            const res = await ApiService.Reminder.GetReminder(reminderId);
            if (res.success) {
                formRef.current.setFieldsValue({
                    ...res.data,
                    reminderDate: moment(new Date(res.data.reminderDate))
                });
                setReminder(res.data)
            }
        }
    }

    const onFinish = async (formData) => {
        if (reminderId) {
            const res = await ApiService.Reminder.EditReminder(reminderId, formData);
            await getReminder();
        }
        else {
            const res = await ApiService.Reminder.CreateReminder({
                ...formData,
                patientId: patientId
            });

            if (res.success) {
                history.push(`/app/system/reminders/edit/?patientId=${res.data.patientId}&reminderId=${res.data.id}`)
            }
        }
    }

    useEffect(() => {
        getReminder()
    }, [reminderId])

    return (
        <SimpleLayout>
            <Card
                title={!reminderId ? t('New') : `${t('Edit')}`}
            >
                <Form
                    ref={formRef}
                    layout={'vertical'}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={t('Reminder Date')}
                        name={'reminderDate'}
                        rules={[
                            { required: true }
                        ]}
                    >
                        <DatePicker
                            format={'DD/MM/yyyy'}
                            locale={Helper.Date.getLocale()}
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('Note')}
                        name={'note'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}